import React from 'react';
import { useSelector } from 'react-redux';

import { BREED_ID } from 'dpl/constants/query_params';
import Icon from 'dpl/common/components/Icon';
import {
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';

import BreederProfileShareButton from './BreederProfileShareButton';
import useBreederProfileMobileLayout from '../../hooks/useBreederProfileMobileLayout';

const ICON_SIZE = '16px';
const BUTTON_CLASSES = 'bg-white ba b--default br-100 pv2 ph2';

function MobileHeader() {
  const {
    server: { breeds, requestReferrer },
    queryParams: { [BREED_ID]: breedId }
  } = useSelector(({ server, queryParams }) => ({ server, queryParams }));

  function handleBackClick() {
    const matchingBreed = breeds.find(breed =>
      requestReferrer.includes(`/${breed.slug}`)
    );

    if (matchingBreed) {
      window.history.back();
    } else if (breedId) {
      const breedSlug = breeds.find(
        breed => breed.id === Number(breedId)
      )?.slug;
      window.location.href = `/${breedSlug}`;
    } else {
      window.location.href = `/${breeds[0].slug}`;
    }
  }

  return (
    <div className="container-xxl bg-sand flex justify-between items-center pb2 pt4">
      <button
        type="button"
        className="flex items-center gap-8"
        onClick={handleBackClick}
      >
        <div className={BUTTON_CLASSES}>
          <Icon
            name="fetch-arrow-left-md"
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        </div>
        <span className="font-16 tertiary">Back to search</span>
      </button>
      <BreederProfileShareButton
        view={ANALYTICS_VIEWS.BREEDER_PROFILE}
        view_feature_location={
          ANALYTICS_VIEW_FEATURE_LOCATIONS.BREEDER_PROFILE_HEADER
        }
        className={BUTTON_CLASSES}
        iconClassName="secondary"
        iconSize={ICON_SIZE}
        aria-label="Share"
      />
    </div>
  );
}

export default function BreederProfileHeader() {
  const { breederDisplayName } = useSelector(({ server }) => server);
  const { isNewMobileLayout } = useBreederProfileMobileLayout();

  if (isNewMobileLayout) {
    return <MobileHeader />;
  }

  return (
    <div className="container-xxl pt3 pt8-md">
      <div className="flex flex-wrap items-center gap-16 pv3 pv8-md">
        <h1 className="BreederProfileShowPage__displayName font-28 md:font-40 lh-title">
          {breederDisplayName}
        </h1>
      </div>
    </div>
  );
}
